import React from 'react';
import { PropTypes } from 'prop-types';
import { ThemeProvider } from '@mui/material';
import MealDetailReadOnlyMobile from './meal_detail_read_only_mobile';
import buildSmorgTheme from '../../theme';
import { useGetSpaceQuery } from '../../app/smorgAppSyncGraphQLApi';

const MealPreviewInUserTheme = ({
  meal,
  descriptionOverride,
  showNutritionMetrics,
}) => {
  const recipe = meal && meal.recipes[0];

  const { data: space } = useGetSpaceQuery();

  const appTheme = buildSmorgTheme(space?.whiteLabelElements);
  console.log(JSON.stringify(space?.whiteLabelElements, null, 2));

  const mealWithDescription = {
    ...meal,
    recipes: [
      {
        ...recipe,
        shortDescription: descriptionOverride || recipe.shortDescription,
      },
    ],
  };

  return (
    <div className="desktopMobilePreview">
      <ThemeProvider theme={appTheme}>
        <MealDetailReadOnlyMobile
          meal={mealWithDescription}
          alwaysShowNutrition
          showMacroRatio
          showNutritionMetrics={showNutritionMetrics}
          derivedNutrition={mealWithDescription.derivedNutrition}
          onIngredientCheckChange={() => {}}
          onEditScaleToServings={() => {}}
          onChangeScaleToServings={() => {}}
          resetScaleToServings={() => {}}
        />
      </ThemeProvider>
    </div>
  );
};

MealPreviewInUserTheme.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  meal: PropTypes.object.isRequired,
  descriptionOverride: PropTypes.string,
  showNutritionMetrics: PropTypes.arrayOf(PropTypes.string).isRequired,
};

MealPreviewInUserTheme.defaultProps = {
  descriptionOverride: null,
};

export default MealPreviewInUserTheme;
